import { useState, useEffect } from "react";
import { mathFormat, showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { LEGEND_BOTTOM } from '@/pages/intelligence/pages/TopCharts/_config/echarts';

export default function useRetentionLineCharts(props: any) {
  const { dateType = 'Month', data, segment } = props;

  const [currentLineData, setCurrentLineData] = useState([]);
  const [xLabel, setXLabel] = useState<any>([]);
  const [seriesData, setSeriesData] = useState([]);
  const [legendSelected, setLegendSelected] = useState({});
  const [legendData, setLegendData] = useState<any[]>([]);

  // console.log('useRetentionLineCharts', props);

  // 获取当前指标echart数据
  const currentLine = (type: string) => {
    let metricType = Object.keys(data);
    if (metricType?.length && metricType?.includes(type)) {
      let source = JSON.parse(JSON.stringify(data))[type];
      setCurrentLineData(source);
    } else {
      setCurrentLineData([]);
    }
  }

  const lineDataFormatter = (list: any) => {
    let xLabel = list[0]?.history?.map((v: any) => showTimeByDateType(v?.time, dateType));
    let _legendSelected = {} as any;
    let _legendData: any[] = [];
    let series = list?.map((v: any, index: any) => {
      let _seriesName = v?.name;
      _legendSelected[`${_seriesName}`] = true;
      let _legendDataItem = {
        name: v?.name,
        icon: 'circle',
      }
      _legendData.push(_legendDataItem);
      return {
        name: v?.name,
        type: 'line',
        symbol: 'circle',
        data: v?.history?.map((item: any) => [showTimeByDateType(item?.time, dateType), item?.value]),
        cover: v?.cover,
      }
    })
    setXLabel(xLabel);
    setSeriesData(series);
    setLegendSelected({ ..._legendSelected });
    setLegendData(_legendData);
  }

  const isMauMetric = segment === 'mau';

  // y轴label格式化
  const yAxisFormatter = (value: any) => {
    if (isMauMetric) {
      return `${mathFormat(value, true)}`;
    }
    return `${mathFormat(value, true)}%`;
  };

  const legendsCustomMade = () => {
    return {
      type: 'scroll',
      orient: 'horizontal', //横向
      pageIconColor: '#000', //翻页箭头颜色
      // selectedMode: false,
      pageIconSize: 12,
      pageTextStyle: {
        color: '#000', //翻页数字颜色
      }, //翻页数字设置
      show: true,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      inactiveColor: '#ccc',//关闭时图例颜色
      inactiveBorderWidth: 0,
      inactiveBorderColor: '#ffffff',//默认存在#ccc，看起来会比设置的icon图例大小有区别
      borderWidth: 0,
      // bottom: 0,
      bottom: LEGEND_BOTTOM,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
        // padding: [0, 30, 0, 0],
      },
      data: [...legendData],
      selected: { ...legendSelected },
      itemGap: 20,
    };
  }

  useEffect(() => {
    lineDataFormatter(currentLineData)
  }, [currentLineData])

  useEffect(() => {
    currentLine(segment || 'D2');
  }, [data, segment]);

  return {
    seriesData: seriesData,
    xAxisData: xLabel,
    yAxisFormatter: yAxisFormatter,
    // tooltipFormatter: tooltipFormatter,
    createLegendsCustomMade: legendsCustomMade(),
    currentLine,
    segment,
  };
}
